import { Component, Input, Output, EventEmitter,OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

import { ApiService } from 'src/app/services/api.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-modal-trazabilidad',
  templateUrl: './modal-trazabilidad.component.html',
  styleUrls: ['./modal-trazabilidad.component.css']
})
export class ModalTrazabilidadComponent implements OnInit {
  titulopant : string = "TRAZABILIDAD TRAMITE ";
  lid_id : string = '0';

  tkt_obsanu : string = '';
  dataTrazabilidad: any;
  
  @Input() tramite: any;

  @Output() cancelClicked = new EventEmitter<void>(); 
  
  constructor(
    private api: ApiService,
    public bsModalRef: BsModalRef
  ) {
    
  }

  ngOnInit() {
    console.log(this.tramite);
    this.lid_id = this.tramite.lid_id;
    this.loadTrazabilidad();
  }

  cancelar() {
    this.cancelClicked.emit();   // opcional
    this.bsModalRef.hide();      // 👈 ESTO CIERRA EL MODAL
  }

  loadTrazabilidad() {
    const data_post = {
      p_tld_id: 0,
      p_lid_id: this.lid_id,
      p_tld_activo: 1
    };

    this.api.gettrazabilidadsel(data_post).subscribe((data: any) => {
      this.dataTrazabilidad = data;
    });
  }
}